import type { TraceToolCall, TraceTurn } from "../types";

const EXTRACTION_CREATE_RE = /\bpaperclip\s+extraction\s+create\b/i;
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const BASH_TOOL_NAMES = new Set(["bash", "papers_bash", "sh"]);

const datasetIdFromOutput = (output: string | undefined): string | null => {
  if (!output) return null;
  const start = output.indexOf("{");
  const end = output.lastIndexOf("}");
  if (start >= 0 && end > start) {
    try {
      const value = JSON.parse(output.slice(start, end + 1)) as {
        id?: unknown;
      };
      if (typeof value.id === "string" && UUID_RE.test(value.id)) {
        return value.id;
      }
    } catch {
      // Fall through to the constrained ID match below.
    }
  }
  const match = output.match(
    /"id"\s*:\s*"([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})"/i,
  );
  return match?.[1] ?? null;
};

const datasetIdFromToolCall = (toolCall: TraceToolCall): string | null => {
  if (
    toolCall.status !== "complete" ||
    !BASH_TOOL_NAMES.has(toolCall.name.toLowerCase())
  ) {
    return null;
  }
  const command =
    typeof toolCall.input?.command === "string" ? toolCall.input.command : "";
  if (!EXTRACTION_CREATE_RE.test(command)) return null;
  return datasetIdFromOutput(toolCall.output);
};

export const latestExtractionDatasetId = (
  traceTurns: TraceTurn[],
): string | null => {
  for (let turnIndex = traceTurns.length - 1; turnIndex >= 0; turnIndex -= 1) {
    const items = traceTurns[turnIndex].items ?? [];
    for (let itemIndex = items.length - 1; itemIndex >= 0; itemIndex -= 1) {
      const item = items[itemIndex];
      if (item.type !== "tool_call") continue;
      const datasetId = datasetIdFromToolCall(item.toolCall);
      if (datasetId) return datasetId;
    }
  }
  return null;
};
